import React from "react";
import AuthTab from "../components/SharedComponent/nav/AuthTab";
import { Outlet } from "react-router";

function AuthPackLayout(props: any) {
  return (
    <div className="app">
      <AuthTab />
      <Outlet />
    </div>
  );
}

export default AuthPackLayout;
